import video1 from "../video/IMG_7679.MOV";
import video2 from "../video/IMG_7691.MOV";
import video3 from "../video/IMG_8354.MOV";


import preview1 from "../img/kitchen/w_01.webp"; 
import preview2 from "../img/bathroom/w_01.webp";
import preview3 from "../img/bathroom/w_03.webp";


export const videos = [

  {
    id: 1,
    src: video1,
    poster: preview2,
    title: "Столешница в ванную комнату из кварцевого агломерата Radianz Everest white.",
    description: "Полированная с двух сторон со стандартной евро фаской. Места примыкания столешницы к плитке были промазаны герметиком и подобраны в цвет плитки заказчика.",
  }, 
   {
    id: 2,
    src: video2,
    poster: preview1,
    title: "Столешница в ванную комнату из кварцевого агломерата Stratos C7109 Cloud Concrete",
    description: "Этапы производства и установки столешницы.",
  },
  {
    id: 3,
    src: video3,
    poster: preview3,
    title: "Столешница в ванную комнату из кварцевого агломерата Belenco Perlo White",
    description: "Монтаж кварцевой столешницы, который включает в себя промазывание силиконом швов с последующим удалением скребком излишков силикона, чтобы шов был гладким и ровным.",
  },
];
